import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../common/components/TextInput';
import { SUBJECT } from '../../constants';

/**
 * New Ticket Subject field component
 */
const Subject = ({ name, onChange, value, error, onBlur }) => (
  <TextInput
    name={name}
    label={SUBJECT.LABEL}
    onChange={onChange}
    onBlur={onBlur}
    classes="animated fadeIn"
    value={value}
    error={error}
  />
);

Subject.propTypes = {
  /** The form name and schema key */
  name: PropTypes.string.isRequired,
  /** Callback for change event */
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  /** The current field value */
  value: PropTypes.string.isRequired,
  /** The possible error of the field */
  error: PropTypes.string
};

export default Subject;
